import AboutImage from '../../assets/about.jpg'
import CV from '../../assets/Stamatis_Platokoukis_CV.pdf'
import { FaFileDownload } from "react-icons/fa"
import data from './data'
import Card from '../../components/Card'
import AOS from 'aos'
import 'aos/dist/aos.css'
import './about.css'
import { useState, useEffect } from 'react';

function useMediaQuery(query) {
  const [matches, setMatches] = useState(window.matchMedia(query).matches);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query);
    const listener = (event) => setMatches(event.matches);

    mediaQueryList.addListener(listener);
    return () => mediaQueryList.removeListener(listener);
  }, [query]);

  return matches;
}

const About = () => {
  useEffect(() => {
    AOS.init({duration: 2000})
  }, [])

  const isTabletOrSmaller = useMediaQuery('(max-width: 600px)');

  return (
    <section id='about'>
      <div className="container about__container">
        <div className="about__left">
          <div className="about__portrait" >
              <img src={AboutImage} alt="About Image" />
          </div>
        </div>
            <div className="about__right">
              <h2 data-aos={isTabletOrSmaller ? undefined : "fade-up"}>About Me</h2>
              <div className="about__cards">
              {
                data.map(item=> (
                  <Card key={item.id} className="about__card">
                    <span className='about__card-icon'>{item.icon}</span>
                    <h5>{item.title}</h5>
                    <small>{item.desc}</small>
                  </Card>
                ))
              }
              </div>
              <p data-aos={isTabletOrSmaller ? undefined : "fade-up"}>
              I hold a Master of Engineering Degree in Mechanical Engineering from NTUA, where I developed essential skills that have shaped my problem-solving approach. These skills have made me a reliable and efficient professional in my field.   
              </p>
              <p data-aos={isTabletOrSmaller ? undefined : "fade-up"}>
              I am passionate about contributing to collaborative environments and thrive in team settings where ideas and goals are shared. With a strong interest in technological advancements, I am particularly focused on leveraging innovation to streamline processes and automate tasks, improving efficiency in the workplace.
              </p>
              <a href={CV} download="Stamatis_Platokoukis_CV.pdf" className='btn primary' data-aos={isTabletOrSmaller ? undefined : "fade-up"}>Download CV
              <FaFileDownload />  
              </a>
        </div>        
      </div> 
    </section>
  );
}

export default About;